// User details secret questions
export * from "./secretQuestions.component";
export * from "./secretQuestions.service";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/secretQuestions/index.ts